import React from 'react';

function CallStatusModal({ status }) {
  return (
    <div className="call-status-modal">
      <h3>Call Status</h3>
      <p>{status}</p>
    </div>
  );
}

export default CallStatusModal;
